import { isNil } from "./ramdaEquivalents.utils";
import { isArray } from "./typeChecks.utils";
var Pluralize = require('pluralize');
export var toLowerCase = function (s) { return isNil(s) ? '' : s.toLowerCase(); };
export function singularize(input) {
    if (!input)
        return '';
    return Pluralize.singular(input);
}
export function pluralize(input) {
    if (!input)
        return '';
    return Pluralize.plural(input);
}
export function autoPluralize(x, singularString, zeroString, pluralString, doNotAutoDisplayNumber) {
    var amount = isArray(x) ? x.length : x;
    if (!amount && zeroString)
        return zeroString;
    if (amount === 1) {
        if (singularString.includes('%d')) {
            return singularString.replace(/%d/, '1');
        }
        if (doNotAutoDisplayNumber)
            return singularString;
        return '1 ' + singularString;
    }
    else {
        var _pluralString = pluralString || pluralize(singularString);
        if (_pluralString) {
            if (_pluralString.includes('%d')) {
                return _pluralString.replace(/%d/, amount + '');
            }
            if (doNotAutoDisplayNumber)
                return _pluralString;
            return amount + ' ' + _pluralString;
        }
    }
    return amount;
}
export function getRandomNumericString(length) {
    if (length === void 0) { length = 8; }
    return (Math.random() * new Date().getTime() + '').replace('.', '').substr(0, length);
}
export var formatSearchString = function (input) {
    return normalizeString(input).toLowerCase().replace(/[\s\n]/gi, '');
};
export var formatSearchStringButIncludeSpace = function (input) {
    return normalizeString(input).toLowerCase().replace(/[^\S ]/gi, '');
};
export function normalizeString(input) {
    return (('' + input) || '').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
export function truncateString(input, upTo, suffix, alwaysConcatSuffix) {
    if (upTo === void 0) { upTo = 20; }
    if (suffix === void 0) { suffix = "…"; }
    if (alwaysConcatSuffix === void 0) { alwaysConcatSuffix = false; }
    if (input.length < upTo)
        return alwaysConcatSuffix ? input.concat(suffix) : input;
    return input.slice(0, upTo).concat(suffix);
}
export function toKebabCase(input) {
    if (isNil(input))
        return '';
    return (input || '').toString().replace(/[A-Z0-9]/g, function ($1) { return "-" + $1.toLowerCase(); }).replace(/\s/g, '').replace(/^-*|-*$/, '');
}
export function toSnakeCase(input) {
    if (isNil(input))
        return '';
    return (input || '').toString().replace(/[A-Z0-9]/g, function ($1) { return "_" + $1.toLowerCase(); });
}
export function toCamelCase(input) {
    if (isNil(input))
        return '';
    return (input || '').toString().replace(/(?:-|_)[a-zA-z0-9]/g, function ($1) { return $1.substr(1).toUpperCase(); });
}
export function toSentenceCase(input) {
    return toKebabCase(input).replace(/-/g, ' ');
}
export function toUpperCase(input) {
    return toSentenceCase(input).toLocaleUpperCase();
}
export function capitalizeFirstLetter(input) {
    var string = '' + input || '';
    return string.replace(/^./, string[0].toUpperCase());
}
export function toTitleCase(input) {
    return toSentenceCase(('' + input)).toString().split(' ').map(function (t) { return (t[0] || '').toUpperCase() + t.substr(1); }).join(' ');
}
